import { RefObject, useCallback, useMemo, useLayoutEffect } from 'react';
import { rem } from 'polished';
import { useIsMounted } from '@hooks/useIsMounted';
import { useSsr } from '@hooks/useSsr';
// eslint-disable-next-line no-restricted-imports
import { max } from 'lodash';

export interface INormalize {
    [x: string]: Array<number | undefined>;
}

export const useContainerHeightNormalize = ({
    containers,
    mainClassName,
    dataSet,
    cb,
    enabled,
}: {
    containers: { [container: string]: { selector: string; element: RefObject<any>; indent?: number } };
    mainClassName: string;
    dataSet?: any;
    cb?: () => any;
    enabled: boolean;
}) => {
    const isMounted = useIsMounted();

    const arrays: { [container: string]: Array<number> } = useMemo(
        () => Object.keys(containers).reduce((a, v) => ({ ...a, [v]: [0], [`ref_${v}`]: containers[v].element }), {}),
        [isMounted()]
    );
    const { isBrowser } = useSsr();

    const normalize = useCallback(
        (props: INormalize) => {
            if (enabled) {
                Object.keys(props).forEach((container: string) => {
                    const items = (props as INormalize)[container]?.filter(Boolean);
                    if (items?.length) {
                        items?.forEach((item: number, k: number) => {
                            if (
                                document.querySelectorAll(`.${container}`)[k] &&
                                (document.querySelectorAll(`.${container}`)[k] as HTMLDivElement).style.height === ''
                            ) {
                                (document.querySelectorAll(`.${container}`)[k] as HTMLDivElement).style.height = rem(
                                    `${max(items)}px`
                                );
                            }
                        });
                    }
                });
            }
        },
        [dataSet, arrays]
    );

    useLayoutEffect(() => {
        cb?.();

        let parsed = {};

        if (isBrowser) {
            for (let i = 0; i <= document.querySelectorAll(`.${mainClassName}`).length; i++) {
                Object.keys(containers).forEach((container) => {
                    if (containers[container].selector) {
                        const element = (document.querySelectorAll(containers[container].selector)[i] as HTMLDivElement)
                            ?.scrollHeight;
                        arrays?.[container]?.push(element + (containers[container].indent ?? 0));
                        parsed = { ...parsed, ...{ [container]: arrays?.[container] } };
                    }
                });
            }
            normalize(parsed);
        }

        return () =>
            Object.keys(containers).forEach((container) => {
                arrays[container] = [0];
            });
    }, [
        isBrowser,
        isMounted(),
        ...Object.keys(containers)
            .map((item) => (arrays?.[`ref_${item}`] as unknown as RefObject<any>)?.current)
            .filter(Boolean),
    ]);
};
